export default "__VITE_ASSET__2WtXGvOu__"